<template>
  <div class="navbar header-main">
    <div class="logo-box">
      <Logo/>
    </div>
    <div class="center-menu">
      <Menus @refresh="refreshRoutes"/>
    </div>

    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <el-avatar size="medium" class="user-avatar" :src="$store.state.user.portrait!=''?$store.state.user.portrait:defaultPotho"></el-avatar>
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="updatePassWord">
            <span style="display:block;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="home-btn" @click="$router.push({path:'/'})">
        <i class="el-icon-s-home"/>
      </div>
    </div>

    <UpdatePassWord ref="UpdatePassWord" />
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import Breadcrumb from "@/components/Breadcrumb";
  import Hamburger from "@/components/Hamburger";
  import ErrorLog from "@/components/ErrorLog";
  import Screenfull from "@/components/Screenfull";
  import SizeSelect from "@/components/SizeSelect";
  import Search from "@/components/HeaderSearch";
  import Menus from "./Menus";
  import Logo from "./Logo";
  import defaultPotho from "@/assets/toux.png";
  import UpdatePassWord from '@/module/admin/layout/components/UpdatePassWord/index'
  export default {
    components: {
      Breadcrumb,
      Hamburger,
      ErrorLog,
      Screenfull,
      SizeSelect,
      Search,
      Menus,
      Logo,
      UpdatePassWord
    },
    data(){
      return {
        defaultPotho: defaultPotho,
      }
    },
    computed: {
      ...mapGetters(["sidebar", "avatar", "device", "permission_routes", 'name'])
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch("app/toggleSideBar");
      },
      updatePassWord() {
        this.$refs.UpdatePassWord.show()
      },
      async logout() {
        await this.$store.dispatch("user/logout");
        this.$router.push(`/login`);
      },
      refreshRoutes(routes, parentName) {
        this.$emit('refreshRoutes', routes, parentName)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .header-main {
    height: 61px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 2000;

    .home-btn {
      display: inline-block;
      width: 61px;
      height: 100%;
      vertical-align: text-bottom;
      font-size: 20px;
      text-align: center;
      color: #fff;
      background: #40c9c6;
      cursor: pointer;
    }

    .logo-box {
      float: left;
      padding-left: 20px;
    }

    .hamburger-container {
      line-height: 57px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      // &:hover {
      //   background: rgba(0, 0, 0, 0.025);
      // }
    }

    .breadcrumb-container {
      float: left;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .center-menu {
      float: left;
      //margin-left: calc(50% - 240px);
      transform: translatex(-50%);
      left:50%;
    position: absolute;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 61px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            // background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-container {
        .avatar-wrapper {
          position: relative;
          height: 61px;
          line-height: 53px;

          .user-avatar {
            cursor: pointer;
            float: left;
            margin-top: 15px;
            margin-right: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
